import { useEffect } from "react";
import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import BreadcrumbTrail from "components/v3/sharedComponents/BreadcrumbTrail";
import NavigationTeamNextMoveCard from "components/v3/sharedComponents/NextMoveCard/NavigationTeamNextMoveCard";
import HealthSurveyNextMoveCard from "components/v3/sharedComponents/NextMoveCard/HealthSurveyNextMoveCard";
import RequestDnaScreeningsNextMoveCard from "components/v3/sharedComponents/NextMoveCard/RequestDnaScreeningsNextMoveCard";
import TestingInProgressNextMoveCard from "components/v3/sharedComponents/NextMoveCard/TestingInProgressNextMoveCard";
import ReviewResultsNextMoveCard from "components/v3/sharedComponents/NextMoveCard/ReviewResultsNextMoveCard";
import CologuardQualificationNextMoveCard from "components/v3/sharedComponents/NextMoveCard/CologuardQualificationNextMoveCard";
import CologuardCheckIn01NextMoveCard from "components/v3/sharedComponents/NextMoveCard/CologuardCheckIn01NextMoveCard";
import CologuardPersonalizedResourcesNextMoveCard from "components/v3/sharedComponents/NextMoveCard/CologuardPersonalizedResourcesNextMoveCard";
import InviteSpouseNextMoveCard from "components/v3/sharedComponents/NextMoveCard/InviteSpouseNextMoveCard";
import CancerReportingNextMoveCard from "components/v3/sharedComponents/NextMoveCard/CancerReportingNextMoveCard";
import ReactivateAccountNextMoveCard from "components/v3/sharedComponents/NextMoveCard/ReactivateAccountNextMoveCard";
import { PATHS } from "constants/pathConstants";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import PageTitle from "utils/PageTitle";
import Translate from "translate/Translate";

const ACTIVE_MEMBER_CARDS: React.FC[] = [
  HealthSurveyNextMoveCard,
  RequestDnaScreeningsNextMoveCard,
  TestingInProgressNextMoveCard,
  ReviewResultsNextMoveCard,
  NavigationTeamNextMoveCard,
  CologuardQualificationNextMoveCard,
  CologuardCheckIn01NextMoveCard,
  CologuardPersonalizedResourcesNextMoveCard,
  InviteSpouseNextMoveCard,
  CancerReportingNextMoveCard
];

const YourNextStepsPage: React.FC = () => {
  const { isMemberActive } = useSelector(selectUserPersonalInformation);
  const cards = isMemberActive
    ? ACTIVE_MEMBER_CARDS
    : [ReactivateAccountNextMoveCard];

  PageTitle("Your Next Steps");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <GradientFramedLayout showHeader={true}>
      <Box
        sx={{
          alignItems: "stretch",
          alignSelf: "flex-start",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: { md: 840, xs: "100%" },
          minWidth: 0,
          paddingBottom: "40px",
          paddingTop: { md: 3, xs: 2 },
          paddingX: { xs: 2, lg: 4 },
          width: "100%"
        }}
      >
        <Typography
          variant="h4_primary"
          component="h1"
          sx={{ fontWeight: 700, textAlign: "left", width: "100%" }}
        >
          <Translate text="Your Next Steps" />
        </Typography>

        <BreadcrumbTrail
          segments={[
            { label: "Dashboard", to: PATHS.LANDING_PAGE },
            { label: "Your Next Steps" }
          ]}
        />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {cards.map((CardComponent, index) => (
            <CardComponent key={index} />
          ))}
        </Box>
      </Box>
    </GradientFramedLayout>
  );
};

export default YourNextStepsPage;
